var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightningCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5964_13235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.251 0.567953C11.3488 0.624692 11.4246 0.712943 11.4658 0.818291C11.507 0.923639 11.5113 1.03985 11.478 1.14795L9.67696 6.99995H13C13.0976 6.99991 13.1931 7.02847 13.2747 7.0821C13.3564 7.13574 13.4205 7.21209 13.4592 7.30175C13.4979 7.3914 13.5095 7.49043 13.4926 7.58661C13.4757 7.68278 13.4309 7.7719 13.364 7.84295L5.36396 16.343C5.28655 16.4253 5.18354 16.4789 5.07173 16.4952C4.95991 16.5115 4.84588 16.4894 4.74823 16.4326C4.65057 16.3757 4.57504 16.2875 4.53395 16.1822C4.49286 16.077 4.48863 15.9609 4.52196 15.853L6.32296 9.99995H2.99996C2.9023 9.99999 2.80677 9.97143 2.72516 9.9178C2.64355 9.86417 2.57943 9.78782 2.54072 9.69816C2.50201 9.60851 2.4904 9.50948 2.50732 9.4133C2.52425 9.31712 2.56896 9.22801 2.63596 9.15695L10.636 0.656953C10.7133 0.574753 10.8161 0.521122 10.9278 0.504782C11.0394 0.488442 11.1533 0.510353 11.251 0.566953V0.567953ZM4.15696 8.99995H6.99996C7.0782 8.99994 7.15536 9.01829 7.22523 9.05353C7.29509 9.08877 7.35571 9.13991 7.4022 9.20285C7.4487 9.26578 7.47978 9.33875 7.49293 9.41588C7.50609 9.49302 7.50096 9.57216 7.47796 9.64695L6.10996 14.09L11.842 7.99995H8.99996C8.92171 7.99997 8.84455 7.98162 8.77468 7.94638C8.70482 7.91114 8.6442 7.86 8.5977 7.79706C8.55121 7.73413 8.52013 7.66116 8.50698 7.58402C8.49382 7.50689 8.49895 7.42774 8.52196 7.35295L9.88996 2.90995L4.15696 8.99995Z",
    fill: "#613D93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5964_13235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningCharge);
export default __webpack_public_path__ + "static/media/lightning-charge.0b33e6a0f3957c374f7ec8d1b423f197.svg";
export { ForwardRef as ReactComponent };